module.exports = __webpack_public_path__ + "img/not-found-note.c6904c6a.svg";